import { MenuItems } from './MenuItems';
import './Navbar.css';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import Tabp from '../../ui/tabpanelfree';
import './Navbar.css';
import CancelIcon from '@mui/icons-material/Cancel';
import { getcaste, getregister } from "./../action/user";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  height: 'auto',
  bgcolor: 'background.paper',
  border: '2px solid #ff6ed',
  boxShadow: 24,
  p: 4,
  borderRadius: '25px'
};

function Navbar({ inSidebar = false, closeSidebar }) {
  const [openspinner, setOpenspinner] = useState(true);
  const [registers, setRegisters] = useState([])
  const getUserData = async () => {
    var test = await getregister();
    setRegisters(test.userValue);
    // console.log(test, "twinkle");
  }

  useEffect(() => {
    //logout(history)
    getUserData();
  }, []);

  const [castes, setCastes] = useState([])
  const getPacksData = async () => {
    var test = await getcaste();
    setCastes(test.userValue);
    // console.log(test, "twinkle");
    // alert(openspinner);
    setInterval(setOpenspinner(!openspinner), 200);

  }

  useEffect(() => {
    //logout(history)
    // setOpenspinner(!openspinner);
    getPacksData();
  }, []);

  const [click, setClick] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => {
    setClick(false);
    if (closeSidebar) {
      closeSidebar(); // Close the parent sidebar
    }
  };

  return (
    <div>
      <div className="navigation">
        <nav className="NavbarItems" >
          {!inSidebar && (
            <div className="menu-icon" onClick={handleClick}>
              <i className={click ? 'bi bi-x' : 'bi bi-list'} style={{ color: 'bl  ack' }}></i>
            </div>)}
          <ul className={inSidebar ? 'nav-menu active' : click ? 'nav-menu active' : 'nav-menu'}>
            {MenuItems.map((item, index) => {
              if (item.title === 'Free Search') {
                return (
                  <li key={index} className="nav-item">
                    <Link
                      className={item.cName}
                      to="/"
                      onClick={(e) => {
                        e.preventDefault();
                        // Redirect to homepage with a hash
                        window.location.href = '/#free-search';
                      }}
                    >
                      {item.title}
                    </Link>
                  </li>
                );
              }

              // Default navigation links
              return (
                <li key={index} className="nav-item">
                  <Link className={item.cName} to={item.url} onClick={closeMobileMenu}>
                    {item.title}
                  </Link>
                  <Link className={item.cName} to={item.url} onClick={closeMobileMenu} style={{ margin: "0px 0px 0px 15px", fontSize: "18px" }}>
                    {item.subtitle}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* <div className="Marq">
          <marquee class="que">
            {castes.map(post => (
              <a style={{ padding: '20px', fontWeight: '800', color: 'white' }} href={"/freesearch?castename=" + post._id}>{post.castename} <span>{"(" + " " + post.registerscount + " " + ")"}</span> </a>
            ))}
          </marquee>
        </div> */}
      </div>
    </div>

  );
}

export default Navbar;
